import * as detect from 'helpers/detect';

// Whether to capture analytics in dev mode (will always capture for production build)
// Set this to `true` to test analytics.
const devEnabled = false;

// Whether to send analytics. DO NOT CHANGE. This is designed to automatically use analytics in production build.
// If you want to enable/disable analytics in dev mode, use the `devEnabled` flag above.
const captureAnalytics = !detect.staticGenerator && (process.env.NODE_ENV === 'production' || devEnabled);

// Google Analytics generated ID
const trackingId = 'UA-113965907-1';



// Initialize GA tracker
export function init() {
	if (captureAnalytics) {
		window.ga('create', trackingId, 'auto');
	}
}


// Report a page view. (Sends immediately, no debouncing)
export function sendPageView(pathname) {
	if (captureAnalytics) {
		window.ga('set', 'page', pathname);
		window.ga('send', 'pageview');
	}
}



// WEBPACK FOOTER //
// ./src/helpers/analytics.js